// -----------------------------------------------------------
// ROSLIBJS CLIENT MODULE
// -----------------------------------------------------------

import ROSLIB from "roslib";

let ros = null;

// -----------------------------------------------------------
// 1) Initialize ROS connection (called from App.js)
// -----------------------------------------------------------
export function initRos(url) {
  console.log("🔌 Connecting to ROSBridge at:", url);

  ros = new ROSLIB.Ros({ url });

  ros.on("connection", () => {
    console.log("🟢 Connected to ROSBridge:", url);
  });

  ros.on("error", (error) => {
    console.error("🔴 ROSBridge Error:", error);
  });

  ros.on("close", () => {
    console.log("🟡 Connection to ROSBridge closed");
  });

  return ros;
}

// Getter
export function getRos() {
  return ros;
}

// -----------------------------------------------------------
// 2) CREATE TOPIC SUBSCRIBER *LAZY* (after ROS exists)
// -----------------------------------------------------------
let current_state_sub = null;
let stateCallback = null;

export function onTemiStateChange(cb) {
  stateCallback = cb;

  if (!ros) {
    console.warn("⚠️ ROS not ready yet; state subscriber will activate later.");
    return;
  }

  // Create subscriber only once
  if (!current_state_sub) {
    current_state_sub = new ROSLIB.Topic({
      ros: ros,
      name: "/temi/current_state",
      messageType: "std_msgs/String"
    });

    current_state_sub.subscribe((msg) => {
      console.log("📩 current_state:", msg.data);
      if (stateCallback) stateCallback(msg.data);
    });
  }
}

// -----------------------------------------------------------
// 3) Lazy service clients (created only when ROS is ready)
// -----------------------------------------------------------
function getSetTrackingClient() {
  if (!ros) {
    console.error("❌ ROS not initialized!");
    return null;
  }

  return new ROSLIB.Service({
    ros: ros,
    name: "/temi/set_tracking_user",
    serviceType: "rosapi_msgs/srv/SetParam"
  });
}

function getSetStateClient() {
  if (!ros) {
    console.error("❌ ROS not initialized!");
    return null;
  }

  return new ROSLIB.Service({
    ros: ros,
    name: "/temi/set_state",
    serviceType: "rosapi_msgs/srv/SetParam"
  });
}

// -----------------------------------------------------------
// 4) Public API for React
// -----------------------------------------------------------
export function setTrackingUser(username) {
  const client = getSetTrackingClient();
  if (!client) return;

  const req = new ROSLIB.ServiceRequest({
    name: username,
    value: ""
  });

  client.callService(req, (res) => {
    if (res.success) {
      alert(`Temi is now tracking: ${username}`);
      console.log("👍 Tracking set:", username);
    } else {
      alert(`Failed: ${res.message}`);
    }
  });
}

export function setState(state) {
  const client = getSetStateClient();
  if (!client) return;

  const req = new ROSLIB.ServiceRequest({
    name: state,
    value: ""
  });

  client.callService(req, (res) => {
    if (res.success) console.log("👍 State set to", state);
    else console.warn("⚠️ Failed to set state:", res.message);
  });
}

// -----------------------------------------------------------
// Optional direct export
// -----------------------------------------------------------
export { ros };
